// Constants
import { Colors } from "@ms/uno-constants/lib/local/Colors";
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
import { PlannerInputHeight } from "../../../constants/StyleConstants";
// Styles
import { memoizeFunction } from "@fluentui/react";
import { dialogControlPlaceholderStyle, dialogControlStyle, fontColorDisabled, fontColorNeutralPrimary, fontColorNeutralSecondary, selectedControlStyle } from "../../../utilities/Mixin.styles";
// Utilities
import { isWindowsHighContrast } from "../../../utilities/ThemingUtilities";
/**
 * Helper to get styles for DatePicker
 * @param theme theme
 */ export const getDatePickerStyles = memoizeFunction((theme)=>{
    const root = {
        "&.is-open, &:focus": {
            "> div .ms-TextField-wrapper > .ms-TextField-fieldGroup": [
                !isWindowsHighContrast() && selectedControlStyle(theme)
            ]
        }
    };
    const callout = [
        {
            ".ms-Callout-main": [
                theme.name === PlannerTheme.HighContrast && {
                    border: `1px solid ${Colors.White}`
                }
            ]
        }
    ];
    return {
        root,
        callout
    };
});
/**
 * Helper to get styles for textField in DatePicker
 * @param theme theme
 * @param isDisabled Whether or not the textfield is disabled
 */ export const getTextFieldStyles = memoizeFunction((theme, isDisabled)=>{
    let msTextFieldFieldBorderRadius = "";
    let msTextFieldFieldGroupIconColor = "";
    let msTextFieldFieldGroupIconHoverColor = "";
    switch(theme.name){
        case PlannerTheme.Light:
            msTextFieldFieldBorderRadius = "3px";
            msTextFieldFieldGroupIconHoverColor = Colors.NeutralDark;
            break;
        case PlannerTheme.Dark:
            msTextFieldFieldBorderRadius = "3px";
            msTextFieldFieldGroupIconColor = Colors.NeutralTertiaryAlt;
            msTextFieldFieldGroupIconHoverColor = Colors.NeutralLight;
            break;
        case PlannerTheme.HighContrast:
            msTextFieldFieldBorderRadius = "3px";
            msTextFieldFieldGroupIconColor = Colors.White;
            msTextFieldFieldGroupIconHoverColor = Colors.TeamsContrastHyperlinkColor;
            break;
        default:
            break;
    }
    // Keep styling priorities for fieldGroup
    const root = {
        ".ms-TextField-wrapper": {
            "> .ms-Label": fontColorNeutralSecondary(theme),
            "> .ms-TextField-fieldGroup": [
                dialogControlStyle(theme)
            ],
            "> .ms-TextField-fieldGroup > .ms-TextField-field": {
                "::placeholder": [
                    isDisabled && fontColorDisabled(theme)
                ]
            }
        },
        "&.is-active": {
            ".ms-TextField-wrapper > .ms-TextField-fieldGroup": [
                selectedControlStyle(theme)
            ]
        }
    };
    const fieldGroup = [
        {
            height: PlannerInputHeight,
            "> .ms-TextField-field": [
                fontColorNeutralPrimary(theme),
                dialogControlPlaceholderStyle(theme),
                {
                    borderRadius: msTextFieldFieldBorderRadius
                },
                isDisabled && [
                    fontColorDisabled(theme),
                    {
                        background: "none transparent",
                        border: "none"
                    }
                ]
            ],
            "i.ms-DatePicker-event--with-label": [
                {
                    color: msTextFieldFieldGroupIconColor
                },
                isDisabled && fontColorDisabled(theme)
            ],
            "&:hover, &:focus": {
                "i.ms-DatePicker-event--with-label": [
                    {
                        color: msTextFieldFieldGroupIconHoverColor
                    },
                    isDisabled && fontColorDisabled(theme)
                ]
            }
        }
    ];
    return {
        root,
        fieldGroup
    };
});
